/**
 * @name: auth
 * @author: Chuwen
 * @date: 2021-04-15 16:55
 * @description：auth
 * @update: 2021-04-15 16:55
 */
 import store from '@/store';
 const shopTokenKey = 'sub-shop-token'
 import { setShop, getShop, sessionSave, sessionRead, setToken } from '@/utils/util';
 import { login, auth, sign, checkPrice } from '@/api/auth';
 import { isShopifyEmbedded } from '@shopify/app-bridge-utils';
 import createApp from '@shopify/app-bridge';
 import { Redirect } from '@shopify/app-bridge/actions';
 import router from '@/router'
 import promotionApi from "@/api/promotion";
 
 export const isRouter = (to, pLoading, val) => {
   if (to.query.host != undefined) {
     sessionSave("host", to.query.host)
   }
   if ((to.query.shop == undefined || to.query.shop == '') && (getShop() == "undefined" || getShop() === false)) {
     router.replace('/login');
   } else if (to.query.shop != undefined && to.query.shop != '') {
     setShop(to.query.shop);
   } else {
     to.query.shop = getShop();
   }
 
   if (to.query.shop != undefined) {
     if (to.query.sign && to.query.shopify_shop_id) {
       sessionSave('auth', 'sign')
       getAuth('sign', to, pLoading, val);
     } else {
       sessionSave('auth', 'login')
       if (to.query.code == undefined || to.query.code == '') {
         getAuth('login', to, pLoading, val);
       } else {
         let domain = window.location.protocol + '//' + window.location.host;
         let params = {
           code: to.query.code,
           domain: domain,
           shop: to.query.shop,
           host: to.query.host,
           state: to.query.state,
           timestamp: to.query.timestamp,
           hmac: to.query.hmac
         }
         auth(params).then(res => {
           if (res.data.data.shop_info.token != "") {
             setToken(res.data.data.shop_info.token);
             SaveInfo(res.data.data.shop_info);
           }
           getRedirect('login', res, to, pLoading, val);
         }).catch((error) => {
           let shop = to.query.shop;
           window.location.replace(getHost(to) + '/auth?shop=' + shop);
         });
       }
     }
   }
 }
 
 // 获取用户权限
 function getAuth(type, to, pLoading, val) {
   let params;
   if (type == 'sign') {
     console.log("getAuth 1")
     params = {
       shopify_shop_id: to.query.shopify_shop_id,
       sign: to.query.sign,
     }
     sign(params).then(res => {
       isSuccess(type, res, to, pLoading);
     }).catch(error => {
       isError(error, pLoading);
     })
   } else {
     console.log("getAuth 2")
     params = {
       shop: to.query.shop,
       redirect_url: getHost(to) + '/auth',
       url: window.location.href
     }
     login(params).then(res => {
       console.log('Authorization success')
       isSuccess(type, res, to, pLoading, val);
     }).catch(error => {
       isError(error);
     })
   }
 }
 
 // 如果成功
 function isSuccess(type, res, to, pLoading, val) {
   // pLoading.finish();
   // Jump authorization required
   if (res.data.data.is_authorization_required) {
     // If your app is embedded inside Shopify, use App Bridge to redirect
     if (isShopifyEmbedded()) {
       const shopifyApp = createApp({
         apiKey: process.env.VUE_APP_API_KEY,
         host: sessionRead("host")
       });
       store.commit("setShopifyAppObj", shopifyApp);
       SaveInfo(res.data.data);
       Redirect.create(shopifyApp).dispatch(Redirect.Action.REMOTE, res.data.data.redirect_url);
       console.log('内嵌重定向')
       // Otherwise, redirect using the `window` object
     } else {
       window.location.assign(res.data.data.redirect_url);
     }
   } else { // 不需要重新跳转拉取权限
     let shopInfo = res.data.data.shop_info ? res.data.data.shop_info : res.data.data;
     if (isShopifyEmbedded()) {
       const shopifyApp = createApp({
         apiKey: process.env.VUE_APP_API_KEY,
         host: sessionRead("host")
       });
       store.commit("setShopifyAppObj", shopifyApp);
     }
     SaveInfo(res.data.data);
     if (shopInfo.token != "") {
       setToken(shopInfo.token)
     }
     if (type == 'sign') {
       router.push({ name: "started" });
     } else {
       getRedirect(type, res, to, val);
     }
   }
 }
 
 // 如果失败
 function isError(error) {
   if (error.response == undefined) {
     console.log("===AuthLogin error===network_error", error);
   } else {
     console.log("===AuthLogin error===network_error", error.response.data.message);
   }
 }
 
 // 授权完成 重定向页面
 function getRedirect(type, res, to, val) {
   if (val != 'main') {
     let appName = process.env.VUE_APP_NAME;
     let isAppEmbedded = process.env.VUE_APP_EMBEDDED;
     if (type != 'sign' && isAppEmbedded == 1 && !isShopifyEmbedded()) {
       let jumpUrl = `https://${to.query.shop}/admin/apps/${appName}/started`;
       window.top.location.href = jumpUrl
     } else {
       router.push({ name: "started" });
     }
   }
 }
 // 存储信息
 function SaveInfo(res) {
   let data = res.shop_info ? res.shop_info : res;
   let willdeskSettings = {
    user_name: data.name || 'no name',
    user_email: data.email || 'no email',
    user_id: 'Upsell_' + data.id || 'no userId',
    shopUrl: data.myshopify_domain || 'no shopName',
    appUserId: 'Upsell - ' +data.id || 'no userId',
    fromApp: 'Upsell', // 改成你们 app名字
    // shopify套餐
    shopifyPlan: data.shopify_plan,
    // 评论者xingming
    reviewName: data.review_name != '' ? data.review_name : 'No review',
    // 评论星级
    review: data.review_rating ? data.review_rating : 0,
    // app套餐
    appPlan: 'Free',
  }
  store.commit('setWillDesk', willdeskSettings)
   // 获取App是否安装
   promotionApi.isPostPurchaseAppInUse().then((res) => {
     if (res.data.code === 0) {
       store.commit("setPostPurchaseActive", res.data.data.is_post_purchase_app_in_use);
     }
   });
   store.commit("setCurrencySymbol", data.currency_symbol);
   if(store.state.pricingPlanId == null) {
     store.commit("setPricingPlanId", data.pricing_plan_id);
   }
   store.commit("setUserName", data.username);
   sessionSave('store', JSON.stringify(store.state))
 }
 
 // 获得当前host地址
 function getHost(to) {
   let wPath = window.document.location.href;
   let pathName = to.path;
   let pos = wPath.indexOf(pathName);
   let localhostPath = wPath.substring(0, pos);
   return localhostPath;
 }
 
 // 查询用户是否收费
 export const isCharge = (to) => {
   checkPrice({ charge_id: to.query.charge_id }).then(res => {
     if (res.data.code == 0) {
       store.commit("setPricingPlanId", res.data.data.pricing_plan_id);
       sessionSave('store', JSON.stringify(store.state))
       if (store.state.shopifyAppObj === null) {
         router.push(to.path);
       } else {
         const shopifyApp = createApp({
           apiKey: process.env.VUE_APP_API_KEY,
           host: sessionRead("host")
         });
         store.commit("setShopifyAppObj", shopifyApp);
         router.push(to.path);
       }
     }
   })
 }
 
 export default {
   getShopToken() {
     try {
       return localStorage.getItem(shopTokenKey)
     } catch (error) {
       return store.state.shopDomain;
     }
   },
   setShopToken(token) {
     try {
       return localStorage.setItem(shopTokenKey, token)
     } catch (error) {
       return false;
     }
   },
   removeAccessToken() {
     try {
       return localStorage.removeItem(shopTokenKey)
     } catch (error) {
       store.commit('setShopDomain', "")
     }
   },
 }